"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var types_1 = require("../types");
exports.CURRENCY_CONFIG = {
    // list of currency that are displayed in the website
    eur: {
        display: '€',
        type: types_1.CurrencyType.symbol,
    },
    gbp: {
        display: '£',
        type: types_1.CurrencyType.symbol,
    },
    hkd: {
        display: 'HKD',
        type: types_1.CurrencyType.code,
    },
    myr: {
        display: 'RM',
        type: types_1.CurrencyType.symbol,
    },
    sgd: {
        display: 'SGD',
        type: types_1.CurrencyType.code,
    },
    thb: {
        display: '฿',
        type: types_1.CurrencyType.symbol,
    },
    usd: {
        display: 'USD',
        type: types_1.CurrencyType.code,
    },
    nzd: {
        display: 'NZD',
        type: types_1.CurrencyType.code,
    },
    aud: {
        display: 'AUD',
        type: types_1.CurrencyType.code,
    },
    jpy: {
        display: '¥',
        type: types_1.CurrencyType.symbol,
    },
    zar: {
        display: 'R',
        type: types_1.CurrencyType.symbol,
    },
    cad: {
        display: 'CAD',
        type: types_1.CurrencyType.code,
    },
    aed: {
        display: 'AED',
        type: types_1.CurrencyType.code,
    },
    rmb: {
        display: 'RMB',
        type: types_1.CurrencyType.code,
    },
    php: {
        display: '₱',
        type: types_1.CurrencyType.symbol,
    },
    chf: {
        display: 'CHF',
        type: types_1.CurrencyType.code,
    },
    dkk: {
        display: 'DKK',
        type: types_1.CurrencyType.code,
    },
    sek: {
        display: 'SEK',
        type: types_1.CurrencyType.code,
    },
    czk: {
        display: 'Kč',
        type: types_1.CurrencyType.symbol,
    },
    pln: {
        display: 'zł',
        type: types_1.CurrencyType.symbol,
    },
    brl: {
        display: 'R$',
        type: types_1.CurrencyType.symbol,
    },
    idr: {
        display: 'Rp',
        type: types_1.CurrencyType.symbol,
    },
    krw: {
        display: '₩',
        type: types_1.CurrencyType.symbol,
    },
    inr: {
        display: 'Rs.',
        type: types_1.CurrencyType.symbol,
    },
    twd: {
        display: 'NT$',
        type: types_1.CurrencyType.symbol,
    },
    nok: {
        display: 'NOK',
        type: types_1.CurrencyType.code,
    },
    omr: {
        display: 'OMR',
        type: types_1.CurrencyType.code,
    },
    fjd: {
        display: 'FJ$',
        type: types_1.CurrencyType.symbol,
    },
    bhd: {
        display: 'BHD',
        type: types_1.CurrencyType.code,
    },
    ars: {
        display: 'AR$',
        type: types_1.CurrencyType.symbol,
    },
    bgn: {
        display: 'лв',
        type: types_1.CurrencyType.symbol,
    },
    xpf: {
        display: 'XPF',
        type: types_1.CurrencyType.code,
    },
    vnd: {
        display: '₫',
        type: types_1.CurrencyType.symbol,
    },
    egp: {
        display: 'EGP',
        type: types_1.CurrencyType.code,
    },
    huf: {
        display: 'Ft',
        type: types_1.CurrencyType.symbol,
    },
    uah: {
        display: 'грн',
        type: types_1.CurrencyType.symbol,
    },
    jod: {
        display: 'JOD',
        type: types_1.CurrencyType.code,
    },
    lak: {
        display: '₭',
        type: types_1.CurrencyType.symbol,
    },
    kwd: {
        display: 'KWD',
        type: types_1.CurrencyType.code,
    },
    mxn: {
        display: 'MXN',
        type: types_1.CurrencyType.code,
    },
    ngn: {
        display: '₦',
        type: types_1.CurrencyType.symbol,
    },
    ils: {
        display: '₪',
        type: types_1.CurrencyType.symbol,
    },
    ron: {
        display: 'lei',
        type: types_1.CurrencyType.symbol,
    },
    pkr: {
        display: 'PKR',
        type: types_1.CurrencyType.code,
    },
    qar: {
        display: 'QAR',
        type: types_1.CurrencyType.code,
    },
    khr: {
        display: '៛',
        type: types_1.CurrencyType.symbol,
    },
    mvr: {
        display: 'Rf',
        type: types_1.CurrencyType.symbol,
    },
    rub: {
        display: '₽',
        type: types_1.CurrencyType.symbol,
    },
    sar: {
        display: 'SAR',
        type: types_1.CurrencyType.code,
    },
    lkr: {
        display: 'රු',
        type: types_1.CurrencyType.symbol,
    },
    bdt: {
        display: 'Tk',
        type: types_1.CurrencyType.symbol,
    },
    kzt: {
        display: '₸',
        type: types_1.CurrencyType.symbol,
    },
    try: {
        display: 'TL',
        type: types_1.CurrencyType.symbol,
    },
    // list of currency that are NOT yet displayed in the website
    afn: {
        display: '؋',
        type: types_1.CurrencyType.symbol,
    },
    awg: {
        display: 'ƒ',
        type: types_1.CurrencyType.symbol,
    },
    azn: {
        display: '₼',
        type: types_1.CurrencyType.symbol,
    },
    bsd: {
        display: '$',
        type: types_1.CurrencyType.symbol,
    },
    bbd: {
        display: '$',
        type: types_1.CurrencyType.symbol,
    },
    byr: {
        display: 'p.',
        type: types_1.CurrencyType.symbol,
    },
    bzd: {
        display: 'BZ$',
        type: types_1.CurrencyType.symbol,
    },
    bmd: {
        display: '$',
        type: types_1.CurrencyType.symbol,
    },
    bob: {
        display: 'Bs.',
        type: types_1.CurrencyType.symbol,
    },
    bam: {
        display: 'KM',
        type: types_1.CurrencyType.symbol,
    },
    bwp: {
        display: 'P',
        type: types_1.CurrencyType.symbol,
    },
    bnd: {
        display: '$',
        type: types_1.CurrencyType.symbol,
    },
    kyd: {
        display: '$',
        type: types_1.CurrencyType.symbol,
    },
    clp: {
        display: '$',
        type: types_1.CurrencyType.symbol,
    },
    cny: {
        display: 'RMB',
        type: types_1.CurrencyType.symbol,
    },
    cop: {
        display: '$',
        type: types_1.CurrencyType.symbol,
    },
    crc: {
        display: '₡',
        type: types_1.CurrencyType.symbol,
    },
    hrk: {
        display: 'kn',
        type: types_1.CurrencyType.symbol,
    },
    cup: {
        display: '₱',
        type: types_1.CurrencyType.symbol,
    },
    dop: {
        display: 'RD$',
        type: types_1.CurrencyType.symbol,
    },
    xcd: {
        display: '$',
        type: types_1.CurrencyType.symbol,
    },
    svc: {
        display: '$',
        type: types_1.CurrencyType.symbol,
    },
    eek: {
        display: 'kr',
        type: types_1.CurrencyType.symbol,
    },
    fkp: {
        display: '£',
        type: types_1.CurrencyType.symbol,
    },
    ghc: {
        display: '¢',
        type: types_1.CurrencyType.symbol,
    },
    gip: {
        display: '£',
        type: types_1.CurrencyType.symbol,
    },
    gtq: {
        display: 'Q',
        type: types_1.CurrencyType.symbol,
    },
    ggp: {
        display: '£',
        type: types_1.CurrencyType.symbol,
    },
    gyd: {
        display: '$',
        type: types_1.CurrencyType.symbol,
    },
    hnl: {
        display: 'L',
        type: types_1.CurrencyType.symbol,
    },
    isk: {
        display: 'kr',
        type: types_1.CurrencyType.symbol,
    },
    irr: {
        display: '﷼',
        type: types_1.CurrencyType.symbol,
    },
    imp: {
        display: '£',
        type: types_1.CurrencyType.symbol,
    },
    jmd: {
        display: 'J$',
        type: types_1.CurrencyType.symbol,
    },
    jep: {
        display: '£',
        type: types_1.CurrencyType.symbol,
    },
    kes: {
        display: 'KSh',
        type: types_1.CurrencyType.symbol,
    },
    kpw: {
        display: '₩',
        type: types_1.CurrencyType.symbol,
    },
    kgs: {
        display: 'лв',
        type: types_1.CurrencyType.symbol,
    },
    lvl: {
        display: 'Ls',
        type: types_1.CurrencyType.symbol,
    },
    lbp: {
        display: '£',
        type: types_1.CurrencyType.symbol,
    },
    lrd: {
        display: '$',
        type: types_1.CurrencyType.symbol,
    },
    ltl: {
        display: 'Lt',
        type: types_1.CurrencyType.symbol,
    },
    mkd: {
        display: 'ден',
        type: types_1.CurrencyType.symbol,
    },
    mur: {
        display: '₨',
        type: types_1.CurrencyType.symbol,
    },
    mnt: {
        display: '₮',
        type: types_1.CurrencyType.symbol,
    },
    mzn: {
        display: 'MT',
        type: types_1.CurrencyType.symbol,
    },
    nad: {
        display: '$',
        type: types_1.CurrencyType.symbol,
    },
    npr: {
        display: '₨',
        type: types_1.CurrencyType.symbol,
    },
    ang: {
        display: 'ƒ',
        type: types_1.CurrencyType.symbol,
    },
    nio: {
        display: 'C$',
        type: types_1.CurrencyType.symbol,
    },
    pab: {
        display: 'B/.',
        type: types_1.CurrencyType.symbol,
    },
    pyg: {
        display: 'Gs',
        type: types_1.CurrencyType.symbol,
    },
    pen: {
        display: 'S/.',
        type: types_1.CurrencyType.symbol,
    },
    shp: {
        display: '£',
        type: types_1.CurrencyType.symbol,
    },
    rsd: {
        display: 'Дин.',
        type: types_1.CurrencyType.symbol,
    },
    scr: {
        display: '₨',
        type: types_1.CurrencyType.symbol,
    },
    sbd: {
        display: '$',
        type: types_1.CurrencyType.symbol,
    },
    sos: {
        display: 'S',
        type: types_1.CurrencyType.symbol,
    },
    srd: {
        display: '$',
        type: types_1.CurrencyType.symbol,
    },
    syp: {
        display: '£',
        type: types_1.CurrencyType.symbol,
    },
    tzs: {
        display: 'TSh',
        type: types_1.CurrencyType.symbol,
    },
    ttd: {
        display: 'TT$',
        type: types_1.CurrencyType.symbol,
    },
    trl: {
        display: '₤',
        type: types_1.CurrencyType.symbol,
    },
    tvd: {
        display: '$',
        type: types_1.CurrencyType.symbol,
    },
    ugx: {
        display: 'USh',
        type: types_1.CurrencyType.symbol,
    },
    uyu: {
        display: '$U',
        type: types_1.CurrencyType.symbol,
    },
    uzs: {
        display: 'лв',
        type: types_1.CurrencyType.symbol,
    },
    vef: {
        display: 'Bs',
        type: types_1.CurrencyType.symbol,
    },
    yer: {
        display: '﷼',
        type: types_1.CurrencyType.symbol,
    },
    zwd: {
        display: 'Z$',
        type: types_1.CurrencyType.symbol,
    },
};
// list of currency that app is displaying with different symbol
exports.APP_CURRENCY_CONFIG = {
    hkd: {
        display: 'HK$',
        type: types_1.CurrencyType.symbol
    },
    sgd: {
        display: 'S$',
        type: types_1.CurrencyType.symbol,
    },
    dkk: {
        display: 'kr',
        type: types_1.CurrencyType.symbol,
    },
    sek: {
        display: 'kr',
        type: types_1.CurrencyType.symbol,
    },
    inr: {
        display: '₹',
        type: types_1.CurrencyType.symbol,
    },
    nok: {
        display: 'kr',
        type: types_1.CurrencyType.symbol,
    },
    ars: {
        display: 'ARS',
        type: types_1.CurrencyType.code,
    },
    bgn: {
        display: 'Лв.',
        type: types_1.CurrencyType.symbol,
    },
    xpf: {
        display: '₣',
        type: types_1.CurrencyType.symbol,
    },
    egp: {
        display: '£',
        type: types_1.CurrencyType.symbol,
    },
    uah: {
        display: '₴',
        type: types_1.CurrencyType.symbol,
    },
    pkr: {
        display: 'Rs.',
        type: types_1.CurrencyType.symbol,
    },
    mvr: {
        display: '.ރ',
        type: types_1.CurrencyType.symbol,
    },
    lkr: {
        display: 'රු,',
        type: types_1.CurrencyType.symbol,
    },
    bdt: {
        display: '৳',
        type: types_1.CurrencyType.symbol,
    },
    try: {
        display: '₺',
        type: types_1.CurrencyType.symbol,
    },
    cny: {
        display: '¥',
        type: types_1.CurrencyType.symbol,
    },
};
exports.CURRENCY_SYMBOL = {};
Object.keys(exports.CURRENCY_CONFIG).forEach(function (code) {
    exports.CURRENCY_SYMBOL[code] = exports.CURRENCY_CONFIG[code].display;
});
//# sourceMappingURL=currencySymbols.js.map